import React, { useEffect, useState } from 'react';
import styles from './Services.module.css';

// Service configuration with local image paths
const servicesList = [
  {
    id: 'seo',
    name: 'SEO',
    description: "Improve your website's visibility in search engines and drive organic traffic with our tailored SEO strategies.",
    image: '/images/services/seo.png',
    fallbackImage: '/images/services/placeholder.png'
  },
  {
    id: 'web-development',
    name: 'Web Development',
    description: 'Transform your online presence with custom-built websites that are fast, responsive, and user-friendly.',
    image: '/images/services/web-development.png',
    fallbackImage: '/images/services/placeholder.png'
  },
  {
    id: 'digital-advertising',
    name: 'Digital Advertising',
    description: 'Reach your target audience with precision through strategic digital ad campaigns across multiple platforms.',
    image: '/images/services/digital-advertising.png',
    fallbackImage: '/images/services/placeholder.png'
  },
  {
    id: 'social-media',
    name: 'Social Media Marketing',
    description: 'Build a strong social media presence that engages your audience and builds brand loyalty.',
    image: '/images/services/social-media.png',
    fallbackImage: '/images/services/placeholder.png'
  },
  {
    id: 'email-marketing',
    name: 'Email Marketing',
    description: 'Connect directly with your audience through targeted email campaigns that convert.',
    image: '/images/services/email-marketing.png',
    fallbackImage: '/images/services/placeholder.png'
  },
  {
    id: 'growth-strategy',
    name: 'Growth Strategy',
    description: 'Develop a comprehensive roadmap for sustainable business growth with actionable plans.',
    image: '/images/services/growth-strategy.png',
    fallbackImage: '/images/services/placeholder.png'
  }
];

const Services = () => {
  // Use an intersection observer to load images only when they come into view
  const [visibleServices, setVisibleServices] = useState([]);
  const [imageLoadErrors, setImageLoadErrors] = useState({});
  
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            setVisibleServices(prev => [...prev, entry.target.dataset.serviceId]);
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '100px', threshold: 0.1 }
    );
    
    const serviceCards = document.querySelectorAll(`.${styles.serviceCard}`);
    serviceCards.forEach(card => observer.observe(card));
    
    return () => {
      serviceCards.forEach(card => observer.unobserve(card));
    };
  }, []);

  const handleImageError = (serviceId) => {
    setImageLoadErrors(prev => ({
      ...prev,
      [serviceId]: true
    }));
  };

  const getImageSrc = (service) => {
    if (imageLoadErrors[service.id]) {
      return service.fallbackImage;
    }
    return service.image;
  };
  
  return (
    <section id="services" className={styles.servicesSection}>
      <div className={styles.container}>
        <div className={styles.sectionHeader}>
          <span className={styles.sectionTag}>OUR SERVICES</span>
          <h2 className={styles.sectionTitle}>What We Offer</h2>
          <p className={styles.sectionDescription}>
            Comprehensive digital marketing solutions to help your business thrive online.
          </p>
        </div>

        <div className={styles.servicesGrid}>
          {servicesList.map((service) => (
            <div 
              key={service.id} 
              className={styles.serviceCard}
              data-service-id={service.id}
            >
              <div className={styles.serviceImageContainer}>
                {visibleServices.includes(service.id) && (
                  <img 
                    src={getImageSrc(service)}
                    alt={service.name} 
                    className={styles.serviceImage}
                    loading="lazy"
                    width="600"
                    height="400"
                    onError={() => handleImageError(service.id)}
                  />
                )}
              </div>
              <h3 className={styles.serviceName}>{service.name}</h3>
              <p className={styles.serviceDescription}>{service.description}</p>
              <a href={`#${service.id}`} className={styles.serviceLink}>
                Learn More
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Services; 